import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { EditingUsers } from '../types'
import { editingUsersSelector } from '../selectors'

export function useEditingUsers() {
  return useSelector<RootState, EditingUsers>(editingUsersSelector)
}
